// src/App.tsx
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "./components/common/Layout";
import { PwaUpdateNotification } from "./components/common/PwaUpdateNotification";
import { HomePage } from "./pages/common/HomePage";
import { TournamentsPage } from "./pages/common/TournamentsPage";
import { TournamentEventPage } from "./pages/common/TournamentEventPage";
import { GeneralRankingPage } from "./pages/common/GeneralRankingPage";
import { GlobalMatchesCalendarPage } from "./pages/common/GlobalMatchesCalendarPage";
import { LoginPage } from "./pages/common/LoginPage";
import { UserProfilePage } from "./pages/common/UserProfilePage";
import { ResetPasswordPage } from "./pages/common/ResetPasswordPage";
import { ForgotPasswordPage } from "./pages/common/ForgotPasswordPage";
import { AboutUsPage } from "./pages/common/AboutUsPage"
import { AdminPage } from "./pages/admin/AdminPage";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { PrivacyPolicyPage } from "./pages/policy/PrivacyPolicyPage"
import { TermsAndConditionsPage } from "./pages/policy/TermsAndConditionsPage"
import { PAGES_ENDPOINTS } from "./config/api";
import { AuthProvider } from "./contexts/AuthContext";
import { currentTenant } from "./tenants";

const App: React.FC = () => {
  useEffect(() => {
    document.documentElement.style.setProperty("--tenant-navbar-bg", currentTenant.theme.navbarBg);
    document.documentElement.style.setProperty("--tenant-navbar-hover-bg", currentTenant.theme.navbarHoverBg);
    document.documentElement.style.setProperty("--tenant-navbar-active-bg", currentTenant.theme.navbarActiveBg);
    document.documentElement.style.setProperty("--tenant-navbar-text", currentTenant.theme.navbarText);
    document.documentElement.style.setProperty("--tenant-navbar-hover-text", currentTenant.theme.navbarHoverText);
    document.documentElement.style.setProperty("--tenant-navbar-active-text", currentTenant.theme.navbarActiveText);
  }, []);
  return (
    <AuthProvider>
      <PwaUpdateNotification />
      <Layout>
        <Routes>
          {/* Rotte pubbliche */}
          <Route path={PAGES_ENDPOINTS.HOME} element={<HomePage />} />
          <Route path={PAGES_ENDPOINTS.TORNEI} element={<TournamentsPage />} />
          <Route path="/tornei/:id" element={<TournamentEventPage />} />
          {currentTenant.enableCalendar && (
            <Route path={PAGES_ENDPOINTS.CALENDARIO} element={<GlobalMatchesCalendarPage />} />
          )}
          <Route path={PAGES_ENDPOINTS.CLASSIFICA} element={<GeneralRankingPage />} />
          <Route path={PAGES_ENDPOINTS.LOGIN} element={<LoginPage />} />
          <Route path={PAGES_ENDPOINTS.RESET_PASSWORD} element={<ResetPasswordPage />} />
          <Route path={PAGES_ENDPOINTS.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
          <Route path={PAGES_ENDPOINTS.USER_PROFILE} element={<UserProfilePage />} />
          <Route path={PAGES_ENDPOINTS.ABOUT_US} element={<AboutUsPage />} />
          {/* Rotte protette */}
          <Route path={PAGES_ENDPOINTS.ADMIN} element={<ProtectedRoute requireAdmin={true}><AdminPage /></ProtectedRoute>} />
          {/* Policy */}
          <Route path={PAGES_ENDPOINTS.COOKIES_PRIVACY} element={<PrivacyPolicyPage />} />
          <Route path={PAGES_ENDPOINTS.CONDITIONS} element={<TermsAndConditionsPage />} />
        </Routes>
      </Layout>
    </AuthProvider>
  );
};

export default App;
